import {
  useGetMyProfileQuery,
  useGetUserBusinessByIdQuery,
  useGetUserBusinessesQuery,
} from 'app/services/user';
import { useEffect } from 'react';
import { useSelector } from 'react-redux';
import { useLocation } from 'react-router-dom';
import {
  selectPrepareQuestionnaire,
  TaxRequestType,
} from '../create/PrepareQuestionnaire/slice';

import {
  autoFillBusinessIndustrySlice,
  autoFillBusinessOwnersSlice,
  autoFillBusinessTypeSlice,
  autoFillCurrentAddressSlice,
  autoFillDependentsSlice,
  autoFillFamilySlice,
  autoFillNameSlice,
  autoFillPrepareQuestionnaire,
  autoFillSelfEmploymentSlice,
} from './autoFill';
import autoFillBusinessGeneralInfoSlice from './autoFillBusinessGeneralInfoSlice';

export default function useCaptureInfo() {
  const { taxRequestType, businessId } = useSelector(
    selectPrepareQuestionnaire,
  );

  const spouseOrDependentId = useSelector(
    selectPrepareQuestionnaire,
  ).spouseOrDependentId;

  const isBusinessTQ = taxRequestType === TaxRequestType.Business;

  const { data: userProfile, isSuccess: isUserProfileCaptured } =
    useGetMyProfileQuery(undefined, {
      skip: !!spouseOrDependentId || isBusinessTQ,
    });
  const { data: userBuisnesses, isSuccess: isUserBuisnessesCaptured } =
    useGetUserBusinessesQuery(undefined, {
      skip: !!spouseOrDependentId || isBusinessTQ,
    });
  const { data: currentBusiness, isSuccess: isCurrentBusinessCaptured } =
    useGetUserBusinessByIdQuery(`${businessId}`, {
      skip: !isBusinessTQ,
    });

  useEffect(() => {
    if (!isUserProfileCaptured || !isUserBuisnessesCaptured) return;

    autoFillNameSlice(userProfile.user);
    autoFillFamilySlice(userProfile.user);
    autoFillDependentsSlice(userProfile.user);
    autoFillCurrentAddressSlice(userProfile.user);
    autoFillPrepareQuestionnaire(userProfile.user);
    autoFillSelfEmploymentSlice(userBuisnesses);
  }, [isUserProfileCaptured, isUserBuisnessesCaptured]);

  useEffect(() => {
    if (!isCurrentBusinessCaptured) return;

    autoFillBusinessTypeSlice(currentBusiness.business);
    autoFillBusinessGeneralInfoSlice(currentBusiness.business);
    autoFillBusinessOwnersSlice(currentBusiness.business);
    autoFillBusinessIndustrySlice(currentBusiness.business);
  }, [isCurrentBusinessCaptured]);

  if (isBusinessTQ) {
    return isCurrentBusinessCaptured;
  }

  return (
    !!spouseOrDependentId || (isUserProfileCaptured && isUserBuisnessesCaptured)
  );
}
